import styled, { keyframes } from 'styled-components';

import { tokens } from '~/styles/tokens';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

export const Content = styled.div`
  display: flex;
  background-color: #000;
  opacity: 0.1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid rgba(247, 142, 30, 0.2);
  border-top-color: ${tokens.colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  z-index: 1;
`;
